import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options extracted from Ruby code (using numeric values for filters)
export const allocationTypeOptions = [
  { value: "0", label: "Equal" },
  { value: "1", label: "ERC" },
  { value: "2", label: "Inverse Volatility" },
  { value: "3", label: "Explicit" },
  { value: "4", label: "Minimum Volatility" },
];

export const rebalancingTypeOptions = [
  { value: "0", label: "No Rebalancing" },
  { value: "1", label: "Daily" },
  { value: "2", label: "Weekly" },
  { value: "3", label: "Monthly" },
  { value: "4", label: "Quarterly" },
  { value: "5", label: "Semi Annually" },
  { value: "6", label: "Monthly FDM" },
  { value: "7", label: "Monthly LDM" },
  { value: "8", label: "Quarterly LDM" },
];

export const statusOptions = [
  { value: "0", label: "Draft" },
  { value: "1", label: "Published" },
];

export const filterVersionsSchema = z.object({
  rebalancing_type_contains: z.string().nullable().optional(),
  allocation_type_contains: z.string().nullable().optional(),
  status_contains: z.string().nullable().optional(),
  start_date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  start_date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterVersionsSchema = z.infer<typeof filterVersionsSchema>;

export const fields: Field[] = [
  {
    name: "rebalancing_type_contains",
    label: "Rebalancing Type",
    type: "select",
    useTranslation: false,
    options: rebalancingTypeOptions,
  },
  {
    name: "allocation_type_contains",
    label: "Allocation Type",
    type: "select",
    useTranslation: false,
    options: allocationTypeOptions,
  },
  {
    name: "status_contains",
    label: "Status",
    type: "select",
    useTranslation: false,
    options: statusOptions,
  },
  {
    name: "start_date_from",
    label: "Start Date From",
    type: "date",
  },
  {
    name: "start_date_to",
    label: "Start Date To",
    type: "date",
  },
];

export const client = "instit-quantilia";

export function FilterVersions() {
  return (
    <FilterTable
      client={client}
      schema={filterVersionsSchema}
      tableName="versions"
      customBuildPath={() => `${client}/versions`}
      fields={fields}
    />
  );
}
